import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MDBModalRef } from "ng-uikit-pro-standard";
import {
  showError,
  showSucess,
} from "src/app/shared/utils/functions/notification.function";

import { IUsuarioEmpresa } from "../../models/perfil.model";
import { CognitoService } from "src/app/shared/services/cognito.service";
import { PerfilService } from "../../services/perfil.service";

@Component({
  selector: "app-modal-validate-token",
  templateUrl: "./modal-validate-token.component.html",
  styleUrls: ["./modal-validate-token.component.scss"],
})
export class ModalValidateTokenComponent implements OnInit {
  mdbRef: MDBModalRef;

  formToken: FormGroup;
  tokenForm: string = "";
  username?: string;
  modo: 'login' | 'perfil' = 'login';

  model: IUsuarioEmpresa;
  emailVerified: boolean;

  constructor(
    public modalRef: MDBModalRef,
    private cognitoService: CognitoService,
    private perfilService: PerfilService
  ) {}

  ngOnInit(): void {
    this.createFormToken(this.tokenForm);

    if (this.modo === 'perfil') {
      if(this.model && this.model.email) {
        this.cognitoService.updateUserEmail(this.model.email).subscribe(
          () => {},
          e => {
            this.close();
            if (e.message === "User is already confirmed") {
              return showError("", "Usuário já está confirmado.");
            }
            return showError("", e.message);
          }
        );
      } else {
        this.close();
        return showError("", "Email do usuário não encontrado. Tente novamente mais tarde.");
      }
    }

    if (this.modo === 'login' && this.username) {
      this.cognitoService.resendEmailCodePublic(this.username).subscribe();
    }
  }

  enviarTokenEmail() {
    if (this.modo === 'login') {
      this.cognitoService.resendEmailCodePublic(this.username)
        .subscribe(
          () => showSucess(
            "Sua solicitação foi recebida com sucesso.",
            "Um novo token foi enviado para o email informado."
          ),
          (e) => showError("", e.message)
        );
    } else {
      this.cognitoService.updateUserEmail(this.model.email)
        .subscribe(
          () => showSucess(
            "Sua solicitação foi recebida com sucesso.",
            "Um novo token foi enviado para o email informado."
          ),
          (e) => showError("", e.message)
        );
    }
  }

  validateEmail() {
    if (this.formToken.invalid) {
      return showError(
        "",
        "Valide as informações do formuário para prosseguir."
      );
    }

    if (this.modo === 'login') {
      this.cognitoService.confirmEmailPublic(this.username, this.tokenFornecido.value)
        .subscribe(() => {
          showSucess(
            "Sua solicitação foi recebida com sucesso.",
            "Agora você pode acessar sua conta."
          );
          this.close();
        }, e => showError("", e.message));

    } else {
      this.cognitoService.verifyNewEmail(this.tokenFornecido.value)
      .subscribe(
        () => this.atualizaCognito(),
        (e) => showError("", e.message)
      );
    }
  }

  atualizaCognito() {
    const cpf = this.model.documentoIdentificador;

    this.perfilService.confirmarUpdate(cpf).subscribe(
      () => {
        showSucess(
            "Sua solicitação foi recebida com sucesso.",
            "Dados para contato atualizados com sucesso."
          );
        this.close();
      },
      (e) => showError("", e.message)
    );
  }

  createFormToken(token: string) {
    this.formToken = new FormGroup({
      token: new FormControl(token, [
        Validators.required,
        Validators.minLength(6),
      ]),
    });
  }

  get tokenFornecido() {
    return this.formToken.get("token");
  }

  close() {
    return this.modalRef.hide();
  }
}
